import { CompletedAppointments } from "@/features/appointments/CompletedAppointments";
import { STAGE_ACTIONS_SECTION_IDS } from "@/features/project/projectTopSection/stages/config";
import { SectionItem } from "@/features/tasks/SectionItem";
import { type Opportunity } from "@repo/api";
import { Tab, TabPanel, Tabs } from "@repo/skapa";
import { t } from "@repo/translation";

import { Tasks } from "./Tasks";

interface ActivitySectionProps {
  opportunity: Opportunity;
  editable?: boolean;
}

export const ActivitySection = ({
  opportunity,
  editable,
}: ActivitySectionProps) => {
  return (
    <SectionItem
      title={t("label.activity")}
      id={STAGE_ACTIONS_SECTION_IDS.UPCOMING_SECTION}
    >
      <Tabs
        tabs={[
          <Tab
            key="activity-section-upcoming__tab"
            text={t("label.upcoming")}
            tabPanelId="activity-section-upcoming"
          />,
          <Tab
            key="activity-section-completed__tab"
            text={t("label.completed")}
            tabPanelId="activity-section-completed"
          />,
        ]}
        tabPanels={[
          <TabPanel
            tabPanelId="activity-section-upcoming"
            key="activity-section-upcoming__tabpanel"
          >
            <Tasks
              opportunity={opportunity}
              editable={editable}
              context="PROJECT"
            />
          </TabPanel>,
          <TabPanel
            tabPanelId="activity-section-completed"
            key="activity-section-completed__tabpanel"
          >
            <CompletedAppointments
              opportunityId={opportunity.id}
              editable={editable}
            />
          </TabPanel>,
        ]}
      />
    </SectionItem>
  );
};
